import React from "react";
import "../styles/AddRelatedBusiness.css";
import { useLocation } from "react-router-dom";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import BackArrow from "../icons/BusinessHub/BackArrow.js";
import Select from "react-select";
import BranchIcon from "../icons/BusinessHub/BranchIcon.js";
import WarehouseIcon from "../icons/BusinessHub/WarehouseIcon.js";
import ManufIcon from "../icons/BusinessHub/ManufIcon.js";
import { userService } from "../services/userService.js";

function AddRelatedBusiness() {
  const { state } = useLocation();
  const companyId = userService.getCompID();

  /************************************* */
  const navigate = useNavigate();
  const [active, setActive] = useState("A");
  const [selectedType, setSelectedType] = useState("");

  const handleSaveAndCont = () => {
    if (!selectedType || !selectedType) return;
    if (selectedType === "BRANCH") {
      navigate("/add-Branch", {
        state: { selectedType },
      });
    }
    if (selectedType === "WAREHOUSE") {
      navigate("/add-Branch", {
        state: { selectedType },
      });
    }
    if (selectedType === "MANUFACTURER") {
      navigate("/add-Branch", {
        state: { selectedType },
      });
    }
  };

  const handleBusinessType = (type) => {
    setSelectedType(type);

    if (type === "delivery") {
      setActive("B");
    }
  };

  /********************************************* */
  return (
    <div className="add-RelatedB-screen-container">
      <div
      // className="add-RelatedB-page-header"
      >
        <BusinessHubHeader />
      </div>
      <div className="add-RelatedB-content-main-container">
        {/* {UserAdd && (
          <div className="edit-user-popup-container">
            <div
              className="edit-user-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="edit-user-popup-content">
                <div className="edit-user-successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="edit-user-successfully-added-text">
                  User Details Updated Successfully
                </div>
                <div
                  className="edit-user-successfully-added-action-button"
                  onClick={() =>
                    navigate("/user-management", {
                      state: { active: "C" },
                    })
                  }
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        )} */}
        <div className="add-RelatedB-content-container">
          <div className="add-RelatedB-header">
            <div className="add-RelatedB-header-navigation">
              <div
                className="add-RelatedB-header-navigation-icon"
                onClick={() =>
                  navigate("/user-management", {
                    state: { active: "A" },
                  })
                }
              >
                <BackArrow />
              </div>
              <div className="add-RelatedB-header-navigation-text">
                Back to Business Overview
              </div>
            </div>
            <div className="add-RelatedB-header-text">
              <div className="add-RelatedB-header-title">
                Add Related Business
              </div>
              <div className="add-RelatedB-header-text-note">
                Select the type of related business entity you want to add to
                your company structure.
              </div>
            </div>
          </div>
          <div className="add-RelatedB-body">
            <div className="add-RelatedB-window-container-select">
              <div className="add-RelatedB-select-busines-type">
                <div className="add-RelatedB-select-type-cont">
                  {/* BRANCH */}
                  <div
                    className={`add-RelatedB-select-vendor ${
                      selectedType === "BRANCH" ? "selected" : ""
                    }`}
                    onClick={() => setSelectedType("BRANCH")}
                  >
                    <div className="select-business-type-vendor">
                      <div className="add-RelatedB-select-vendor-icon">
                        <BranchIcon />
                      </div>

                      <div className="add-RelatedB-select-type">Branch</div>

                      <div className="add-RelatedB-select-type-text">
                        Add a branch location for your business operations
                      </div>
                    </div>
                  </div>

                  {/* WAREHOUSE */}
                  <div
                    className={`add-RelatedB-select-vendor ${
                      selectedType === "WAREHOUSE" ? "selected" : ""
                    }`}
                    onClick={() => setSelectedType("WAREHOUSE")}
                  >
                    <div className="select-business-type-vendor">
                      <div className="add-RelatedB-select-vendor-icon">
                        <WarehouseIcon />
                      </div>

                      <div className="add-RelatedB-select-type">Warehouse</div>

                      <div className="add-RelatedB-select-type-text">
                        Add a warehouse facility for storage and distribution
                      </div>
                    </div>
                  </div>

                  {/* MANUFACTURER */}
                  <div
                    className={`add-RelatedB-select-vendor ${
                      selectedType === "MANUFACTURER" ? "selected" : ""
                    }`}
                    onClick={() => setSelectedType("MANUFACTURER")}
                  >
                    <div className="add-RelatedB-select-delivery-container">
                      <div className="add-RelatedB-select-delivery-icon">
                        <ManufIcon />
                      </div>

                      <div className="add-RelatedB-select-type">
                        Manufacturer
                      </div>

                      <div className="add-RelatedB-select-type-text">
                        Add a manufacturing facility to your business structure.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="add-RelatedB-footer">
                <div className="add-RelatedB-footer-action-buttons">
                  {/* <div
                    className="add-RelatedB-nav-button-container"
                    onClick={() =>
                      navigate("/user-management", {
                        state: { active: "A" },
                      })
                    }
                  >
                    <div className="add-RelatedB-button-icon">
                      <BackArrow />
                    </div>
                    <div className="add-RelatedB-button-text">
                      Back to Business Overview
                    </div>
                  </div> */}
                  <div
                    className="add-RelatedB-continue-button"
                    onClick={() => handleSaveAndCont()}
                  >
                    Continue
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddRelatedBusiness;
